import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const memberTabs = [
  { to: '/dashboard',  icon: '📊', label: 'Home'    },
  { to: '/workouts',   icon: '🏋️', label: 'Workout' },
  { to: '/checkin',    icon: '📲', label: 'Check-in' },
  { to: '/nutrition',  icon: '🥗', label: 'Food'    },
  { to: '/progress',   icon: '📸', label: 'Progress' },
];

const adminTabs = [
  { to: '/admin/dashboard',  icon: '📊', label: 'Dashboard' },
  { to: '/admin/members',    icon: '👥', label: 'Members'   },
  { to: '/admin/attendance', icon: '📋', label: 'Attendance'},
  { to: '/admin/plans',      icon: '💳', label: 'Plans'     },
];

export default function BottomNav({ isAdmin }) {
  const location = useLocation();
  const tabs = isAdmin ? adminTabs : memberTabs;

  // Only show on mobile (detected via CSS, but we also hide on wide screens via media query)
  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#13161d',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      paddingBottom: 'env(safe-area-inset-bottom)',
      zIndex: 80,
      // Hide on desktop — only show on mobile
    }} className="bottom-nav">
      {tabs.map(tab => {
        const active = location.pathname === tab.to ||
          (tab.to !== '/dashboard' && tab.to !== '/admin/dashboard' && location.pathname.startsWith(tab.to));
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
              padding: '10px 8px 8px',
              textDecoration: 'none',
              flex: 1,
              transition: '.12s',
              color: active ? '#4f7ef8' : '#525e72',
            }}
          >
            <span style={{ fontSize: 22, lineHeight: 1 }}>{tab.icon}</span>
            <span style={{
              fontSize: 10,
              fontWeight: active ? 600 : 400,
              color: active ? '#4f7ef8' : '#525e72',
            }}>
              {tab.label}
            </span>
          </NavLink>
        );
      })}
    </nav>
  );
}
